import React, { useState, useEffect } from "react";
import Backarrow from "../../components/backarrow/Backarrow";
import Button from "../../components/button/Button";
import "./Otp.css";
import { useLocation, useHistory } from "react-router-dom";
import OtpInput from "react-otp-input";
import {
  otp_mail_login,
  otp_mobile_login,
  otp_mail,
  resend_otp,
} from "../../api/auth";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { set_profile, signup_user } from "../../store/User";
import { profile_details } from "../../api/profile";

const Otp = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");
  const [viaEmail, setViaEmail] = useState(true);
  const [loading, setLoading] = useState(false);
  const [resend, setResend] = useState(false);
  const [secs, setSecs] = useState(15);
  const [resendOpt, setResendOpt] = useState(false);
  const history = useHistory();
  const state = location.state ? location.state : {};
  const email = state.email;
  const mobile = state.mobile;
  const token = useSelector((state) => state.user.token);
  const redirectPath = new URLSearchParams(history.location.search).get(
    "redirectPath"
  );

  const handle_resend = async (type) => {
    setResendOpt(false);
    setResend(false);
    resendTimer();
    setSecs(30);
    if (viaEmail) {
      //send otp via email
      const sent = await otp_mail(email);
      if (sent.error) {
        toast.error(sent.error, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
      }
    } else {
      console.log("sending otp via sms");
      // send otp via sms
      const sent = await resend_otp(token, type);
      if (sent.error) {
        toast.error(sent.error, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        history.push({ pathname: "/otp", state: { type: "mobile", mobile } });
      }
    }
  };
  const resendTimer = () => {
    if (!resend) {
      setInterval(
        () =>
          setSecs((secs) => {
            if (secs > 0) {
              return secs - 1;
            } else {
              setResend(true);
              return 0;
            }
          }),
        1000
      );
    }
  };

  const otp_login = async () => {
    setLoading(true);
    if (viaEmail) {
      const token = await otp_mail_login({ otp, email });
      if (token.error) {
        setLoading(false);
        toast.error(token.error, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        dispatch(signup_user(token.data.data));
        localStorage.setItem("token", token.data.data);
        const details = await profile_details(token.data.data);
        dispatch(set_profile(details.data.data));
        localStorage.setItem("profile", JSON.stringify(details.data.data));
        setLoading(false);
        if (redirectPath) {
          history.push({ pathname: redirectPath, search: "?loggedIn=true" });
        } else {
          history.push("/profile");
        }
      }
    } else {
      const token = await otp_mobile_login({ otp, mobile });
      if (token.error) {
        setLoading(false);
        toast.error(token.error, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        dispatch(signup_user(token.data.data));
        localStorage.setItem("token", token.data.data);
        setLoading(false);
        history.push("/profile");
      }
    }
  };
  // const timer = () => {
  //  ;
  // };

  useEffect(() => {
    if (state.type === "email") {
      setViaEmail(true);
    } else {
      setViaEmail(false);
    }
    if (!resend) {
      setInterval(
        () =>
          setSecs((secs) => {
            if (secs > 0) {
              return secs - 1;
            } else {
              setResend(true);
              return 0;
            }
          }),
        1000
      );
    }
  }, [resend, state.type]);
  return (
    <div className="otp__screen">
      <Backarrow />

      <div className="opt__body">
        <h1 className="otp__heading">
          Enter <span>OTP</span> to Login
        </h1>
        {viaEmail ? (
          <p className="otp__msg">
            Enter OTP sent to you via e-mail on your id {email}
          </p>
        ) : (
          <p className="otp__msg">Enter OTP sent to you via SMS on {mobile}</p>
        )}
        <OtpInput
          value={otp}
          onChange={(otp) => setOtp(otp)}
          numInputs={6}
          // separator={""}
          inputStyle="opt__box"
          containerStyle="otp__wrapper"
          separator={<span>&nbsp;</span>}
          isInputNum="true"
        />
        {resend ? (
          <div className="resend__btn">
            {!resendOpt ? (
              <span onClick={viaEmail ? resend_otp : () => setResendOpt(true)}>
                Re-send OTP
              </span>
            ) : (
              <span className="resend__otps">
                <span onClick={() => handle_resend("SMS")}>
                  Re-send via sms
                </span>
                -
                <span onClick={() => handle_resend("CALL")}>
                  Re-send via call
                </span>
              </span>
            )}
          </div>
        ) : (
          <div className="resend__text">Re-send OTP (After {secs}s)</div>
        )}
      </div>
      <div className="vo__lower">
        <Button
          text="Sign In"
          click={otp_login}
          loading={loading}
          style={
            otp.length < 6
              ? { background: "lightgrey", pointerEvents: "none" }
              : ""
          }
        />
      </div>
    </div>
  );
};

export default Otp;
